import dictionary from './dictionary.json';
const config = {
    resource: 'next-installation-services',
    dictionary,
};
export default config;
//# sourceMappingURL=config.js.map